import { Flex } from "@radix-ui/themes";
import PekyLogo from "./icons/peky-logo.svg?react";
import { DebugLogoTrigger } from "./debug-menu";
import { VersionBadge } from "./version-badge";

// The Peky brand logo as shown in screen headers, with the active version badge
// beside it. Kept in one place so the logo + version stay consistent across the
// enter/exit/out-of-service screens.
export function BrandLogo() {
  return (
    <Flex align="center" gap="2">
      <DebugLogoTrigger>
        <PekyLogo height={38} />
      </DebugLogoTrigger>
      <VersionBadge />
    </Flex>
  );
}
